import React from "react";
import Headerdash from "./head";
import Sidebar from "./sidebar";
import { useNavigate } from 'react-router-dom';
import { Cpu } from "lucide-react";

export default function Practice() {
    const navigate = useNavigate();

    const handleClick = (destination) => {
        navigate(destination);
    };

    return (
        <div className="relative min-h-screen flex flex-col md:flex-row">
            <Headerdash />
            <Sidebar />
            <div className="md:ml-80 mt-32 p-4 w-full max-w-6xl">
                {[
                    { title: "Speaking Zone", color: "bg-green-300", hover: "hover:bg-green-500", buttons: [
                        { label: "Read Aloud", path: "/practice/readaloud" },
                        { label: "Repeat Sentence", path: "/practice/repeatsentence" },
                        { label: "Describe Image", path: "/practice/describeimage" },
                        { label: "Re-Tell Lecture", path: "/practice/re-tell-lectures" },
                        { label: "Short Questions", path: "/practice/shortquestions" },
                        { label: "Summarize Group Discussion", path: "/practice/summarizegroupdiscussion" },
                        { label: "Respond to a Situation", path: "/practice/respondtosituation" }
                    ]},
                    { title: "Writing Zone", color: "bg-blue-300", hover: "hover:bg-blue-500", buttons: [
                        { label: "Summarize written text", path: "/practice/summarize-written-text" },
                        { label: "Write Essay", path: "/practice/write-essay" }
                    ]},
                    { title: "Reading Zone", color: "bg-orange-300", hover: "hover:bg-orange-500", buttons: [
                        { label: "Multiple Type, Single Answer", path: "/practice/reading-zone/single-answer" },
                        { label: "Multiple Type, Double Answer", path: "/practice/reading-zone/double-answer" },
                        { label: "Reorder Paragraph", path: "/practice/reading-zone/re-order-paragraph" },
                        { label: "Reading Fill in the Blanks", path: "/practice/reading-zone/fill-in-the-blanks" },
                        { label: "Fill in the Blanks Reading & Writing", path: "/practice/reading-zone/reading-and-writing" }
                    ]},
                    { title: "Listening Zone", color: "bg-purple-400", hover: "hover:bg-purple-600", buttons: [
                        { label: "Summarize Spoken text", path: "/practice/listening-zone/summarize-spoken-text" },
                        { label: "MCQ Single Answer", path: "/practice/listening-zone/mcq-single-answer" },
                        { label: "MCQ Multiple Answer", path: "/practice/listening-zone/mcq-double-answer" },
                        { label: "Fill In the Blanks", path: "/practice/listening-zone/fill-blanks" },
                        { label: "Highlight Correct Summary", path: "/practice/listening-zone/highlight-correct-summary" },
                        { label: "Select Missing Word", path: "/practice/listening-zone/select-missing-words" },
                        { label: "Highlight Incorrect Word", path: "/practice/listening-zone/hightlight-incorrect-words" },
                        { label: "Write from Dictation", path: "/practice/listening-zone/write-from-dictation" }
                    ]}
                ].map((section, index) => (
                    <div key={index} className="w-full md:w-11/12 bg-gray-100 rounded-md p-4 mb-4">
                        <h2 className="text-2xl font-bold text-gray-800 sm:text-3xl mb-4">{section.title}</h2>
                        <div className="flex flex-wrap gap-4">
                            {section.buttons.map((btn, i) => (
                                <button 
                                    key={i} 
                                    onClick={() => handleClick(btn.path)} 
                                    className={`${section.color} ${section.hover} text-white font-bold py-2 px-4 rounded-sm flex items-center gap-2`}
                                >
                                    <Cpu size={18} />
                                    {btn.label}
                                </button>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}